import dayjs from 'dayjs'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { DocumentTemplate } from './DocumentTemplate'
import { useRoute } from 'wouter'
import React from 'react'
import { DocumentVersion } from '@/lib/api/client'

export const MAX_VERSIONS_PER_PAGE = 12
export const VersionHistoryDocument = ({
  versionName,
  createdAt,
  isLatestDocumentVersion,
  parentRef,
  versions,
  index,
}: {
  versionName: string
  createdAt: string
  isLatestDocumentVersion?: boolean
  parentRef?: any
  versions: Array<DocumentVersion>
  index: number
}) => {
  const [isPrintPage] = useRoute(/print$/)
  const Wrapper = isPrintPage ? React.Fragment : 'div'

  return (
    <Wrapper ref={parentRef}>
      <DocumentTemplate
        id={`history--${index}`}
        title="Version History"
        createdAt={createdAt}
        versionName={versionName}
        isLatestDocumentVersion={isLatestDocumentVersion}
        order={2 + index}
      >
        <div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Version</TableHead>
                <TableHead>Last Updated</TableHead>
                <TableHead>Published by</TableHead>
                <TableHead>Notes</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {versions.map((version, i) => (
                <TableRow key={i}>
                  <TableCell className="py-1 px-2.5">
                    {version.name || `V${version.version_number || 1}`}
                  </TableCell>
                  <TableCell className="py-1 px-2.5">
                    {dayjs(
                      version.modified ||
                        version.created ||
                        new Date().toISOString(),
                    ).format('MMM DD, YYYY hh:mm a')}
                  </TableCell>
                  <TableCell className="py-1 px-2.5">
                    {version.creator?.first_name || ''}{' '}
                    {version?.creator?.last_name || ''}
                  </TableCell>
                  <TableCell className="py-1 px-2.5">
                    {version.comment}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DocumentTemplate>
    </Wrapper>
  )
}
